__turbopack_context__.v({
  "body24": "Paragraph-module__YvRM2G__body24",
  "lead": "Paragraph-module__YvRM2G__lead",
  "leadAlert": "Paragraph-module__YvRM2G__leadAlert",
  "leadBody": "Paragraph-module__YvRM2G__leadBody",
  "paragraph": "Paragraph-module__YvRM2G__paragraph",
});
